export default "__VITE_ASSET__DsMBhvMP__"